import React, { useState,useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import { Constants } from '../Constants';
import { getmasterdetails, getsitedata, getUserDetails, getUserPermissionDetails } from '../services/appservice';
import Error from '../components/Error';
import { ApplicationState } from '../store';
import * as AppStore from '../store/AppDataContainer';
import ComponentBuilder from './ComponentBuilder';
import { DataManager } from '../common/DataManager';
import * as DynamicScripts from '../common/DynamicScripts';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import CustomLoader from './CustomLoader/CustomLoader';
const queryString = require('query-string');
var decode = require('decode-html');

const Preview = () => {
    const appState = useSelector(state => state) as ApplicationState;
    const dispatch = useDispatch();
    let dataManager = new DataManager(appState);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [userAuthenticted, setUserAuthenticted] = useState({ IsAuthorized: false, IsLoaded : false});

    const renderHtml = () => {
        return (

            isPageLoaded(appState) ? (userAuthenticted && userAuthenticted.IsAuthorized && userAuthenticted.IsLoaded ? <ComponentBuilder /> : <Error />) :
                <CustomLoader />
                // <LoadingOverlay
                //     active={true}
                //     spinner
                //     text='Page Loading ......'
                // >
                // </LoadingOverlay>
        );
    }

    const isPageLoaded = (appState: ApplicationState) => {
        if ((pageLoaded && userAuthenticted.IsLoaded) || (userAuthenticted && userAuthenticted.IsLoaded && appState.appStore && appState.appStore.DataSources && appState.appStore.DataSet && appState.appStore.DataSources.filter(t => t.NotDefaultLoaded === undefined || t.NotDefaultLoaded === false).length === appState.appStore.DataSet.length)) {
            return true;
        }
        else {
            return false;
        }
    }

    interface KayValue {        
        [key: string]: any
    }

    const getAppDataSuccessHandler6 = (data:any) => {
        if (data.data && data.data.SiteConfiguration) {
            //dispatch(AppStore.layoutActionCreators.setAppState({ Components: data.data.SiteConfiguration.SubPortals.ContentLayout.XPControls, DataSources: data.data.SiteConfiguration.SubPortals.ResourceAPIConfiguration }));
            let dataManager = new DataManager(appState);
            dataManager.loadDataSources(data.data.SiteConfiguration.SubPortals.ResourceAPIConfiguration, getPageDataSuccessHandler);
        }
    }

    const getUserPermissionDetailsHandler = (data: any) => {
        if (data.data) {
            const cookies = new Cookies();
            if (data.data[0].isAuthenticated && data.data[0].isAuthorized) {
                cookies.set("LoginId", data.data[0].userName);
                cookies.set("UserEmailId", data.data[0].eMail);
                cookies.set("UserDomainName", data.data[0].user);
                // setUserAuthenticted({ 'IsAuthorized' : true,'IsLoaded' : true});
                getUserPermissionPageHandler(data?.data[0]?.user);
            }
            else {
                setUserAuthenticted({ 'IsAuthorized': false, 'IsLoaded': true });
            }
        }
    }

    useEffect(()=>{
        getUserPermissionPageHandler("");
        // getUserPermissionDetails({}, getUserPermissionDetailsHandler);
    },[])

    const getAppDataSuccessHandler = (data: any) => {
        if (data.data && data.data.SiteConfiguration) {
            data.data.SiteConfiguration['IsAuthorized']=true;
            data.data.SiteConfiguration['AuthorizedPages']=[];
            let siteConfiguration = data.data.SiteConfiguration as AppStore.SiteConfiguration;
            let layoutContent = siteConfiguration.Layout ? siteConfiguration.Layout : "";
            let layout: AppStore.Layout = layoutContent ? JSON.parse(layoutContent).Layout : null;           
            dispatch(AppStore.layoutActionCreators.setAppState({AuthorizedPages:siteConfiguration?.AuthorizedPages, SiteConfiguration: siteConfiguration, Layouts: layout ? [layout] : [], DataSources: siteConfiguration.DataSource ? siteConfiguration.DataSource : [], RefreshPage:true }) as any);
            let dataManager = new DataManager(appState);    

            if (siteConfiguration?.IsAuthorized) {
                // getUserPermissionDetails({ 'GroupName': siteConfiguration.ExperienceSecurityGroup }, getUserPermissionDetailsHandler);
                setUserAuthenticted({ 'IsAuthorized': true, 'IsLoaded': true });
                if (siteConfiguration && siteConfiguration.DynamicScripts && siteConfiguration.DynamicScripts.length > 0) {
                    let onloadScript = siteConfiguration.DynamicScripts[0];
                    if (onloadScript && onloadScript.Script) {
                        var funExpression = eval("(AppStore,appState,dataManager,dataContainer,NotificationManager) => {" + decode(onloadScript.Script) + "}");
                        let result = funExpression(AppStore, appState, dataManager, siteConfiguration,NotificationManager);
                    }
                }
    
                if (siteConfiguration.DataSource && siteConfiguration.DataSource.length > 0) {
                    dataManager.loadInitialDataSources(siteConfiguration.DataSource ? siteConfiguration.DataSource : [], getPageDataSuccessHandler);
                }
                else {
                    setPageLoaded(true);
                } 
            }
            else {
                setUserAuthenticted({ 'IsAuthorized': false, 'IsLoaded': true });
                setPageLoaded(true);
            }          
        }
    }

    const getPageDataSuccessHandler = (data: any, key: string, itemPath: string, itemIndex: number) => {
        let result = DynamicScripts.EvaluteExpression("$$t." + itemPath.trim(), data, itemIndex, appState,null);
        let dataSet: KayValue = {};
        dataSet[key] = result;
        dispatch(AppStore.layoutActionCreators.setAppDataSet({}, dataSet,key) as any);            
        //mergerAPIwithMockData(datacontainer[key], dataStore.GetData(Constants.MockData) && dataStore.GetData(Constants.MockData).mockdatacontainer ? dataStore.GetData(Constants.MockData).mockdatacontainer[key] : dataStore.GetData(Constants.MockData));        
    }

    const getUserPermissionPageHandler=(user:string)=>{       
        var page = window.location.pathname.substring(1);
        var parsed = queryString.parse(window.location.search);
        const cookies = new Cookies();
        /*
        if (window.location.search !== "") {
            cookies.set(Constants.QueryString, parsed);
        }
        else {
            parsed = cookies.get(Constants.QueryString) ? cookies.get(Constants.QueryString) : parsed;
        }
        */
        //dispatch(AppStore.layoutActionCreators.setAppState({ QueryStringParams: parsed, Layouts: [JSON.parse(Constants.LayoutString).Layout], RouteUrl: queryString.parseUrl(page).url }));
        dispatch(AppStore.layoutActionCreators.setAppState({ QueryStringParams: parsed, RouteUrl: queryString.parseUrl(page).url }) as any);
        if (appState.appStore && appState.appStore.QueryStringParams) {
            appState.appStore.QueryStringParams = parsed;
            appState.appStore.RouteUrl = queryString.parseUrl(page).url;
        }
        
        //dataStore.SetData(Constants.QueryString, parsed);
        //dataStore.SetData(Constants.RouteUrl, queryString.parseUrl(page).url);

        //const request = { "container": ["root"], "routePath": page };
        var request: KayValue;
        //page = "studio/home";
        //request = { container: ["root"], routePath: page };
        //page = "SupportStudioApp/SupportStudio";
        request = { container: ["en/us"], routePath: page };

        if (parsed['p'] !== undefined && parsed['p'] !== null) {
            request['p'] = parsed['p'];
        }
    
        if (parsed['f'] !== undefined && parsed['f'] !== null) {
            request.p = parsed['f'];
        }
    
        //if ((parsed['c'] !== undefined && parsed['c'] !== null) && (parsed['l'] !== undefined && parsed['l'] !== null)) {
        //    request.container = [parsed['l'] + "/" + parsed['c']];
        //}
        request.refreshCache = true;
        request.User=user
        //if (parsed['User'] !== undefined && parsed['User'] !== null) {
        //    request.user = parsed['User'];
        //}
        //else {
        //    request.user = "";
        //}
        //request.appGroups = ["studio"];
        //getmasterdetails(request, getAppDataSuccessHandler);

        if (appState && appState.appStore && appState.appStore.ContextData) {
            let server = appState.appStore.ContextData.find(t => t.path === "AppSettings:SiteDataAPIServer").value;
            let indexType = appState.appStore.ContextData.find(t => t.path === "AppSettings:IndexType")?.value?.toLowerCase();
            indexType = indexType == undefined ? 'draft' : indexType;

            if (appState.appStore.ContextData.find(t => t.path === "AppSettings:EnvConfigApplicableRouteUrls")?.value != undefined && !appState.appStore.ContextData.find(t => t.path === "AppSettings:EnvConfigApplicableRouteUrls")?.value?.toLowerCase()?.split(',')?.includes(appState.appStore.RouteUrl?.toLowerCase())) {
                indexType = 'draft';
            }
            request['IndexType'] = indexType;
                     
            appState.appStore.QueryStringParams.env = indexType == 'approved' ? 'prod' : 'dev';
            console.log("SiteDataAPIServer : " + server + ", indexType : " + indexType);
            getsitedata(server, request, getAppDataSuccessHandler);
        }          
        
    }

    return renderHtml();
}

export default connect((state: ApplicationState) => state.appStore,
    AppStore.layoutActionCreators
)(Preview);
